var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tik Tok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.28438 11.2283C5.86079 11.301 5.43719 11.301 5.0842 11.4465C3.63692 11.8829 2.71914 13.4103 3.00154 14.9378C3.28393 16.5743 4.62531 17.6289 6.24908 17.4835C7.80225 17.3744 9.07303 16.0651 9.07303 14.5014C9.10833 11.6283 9.10833 8.75534 9.10833 5.9187C9.10833 4.13671 9.10833 2.35472 9.10833 0.5C9.99082 0.5 10.8733 0.5 11.7205 0.5C11.7911 0.5 11.897 0.645469 11.897 0.718203C12.4265 3.373 14.0149 4.82769 16.5565 5.22773C16.5565 5.22773 16.5918 5.22773 16.6271 5.2641C16.6271 6.31874 16.6271 7.37339 16.6271 8.53714C14.6503 8.64624 13.0972 7.88253 11.8264 6.17328C11.8264 6.46421 11.8264 6.60968 11.8264 6.79152C11.8264 9.30085 11.8264 11.8102 11.8264 14.3559C11.8264 17.5198 9.56722 20.1019 6.56677 20.4656C3.56633 20.7929 0.812973 18.7563 0.142285 15.6651C-0.634302 11.9557 2.15435 8.31894 5.82549 8.31894C5.96668 8.31894 6.10788 8.3553 6.24908 8.3553C6.28438 9.33722 6.28438 10.3191 6.28438 11.2283Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/Tik_Tok.da646374.svg";
export { ForwardRef as ReactComponent };